import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';
import {DataService} from '../../../../Services/data.service';
import { StorageService } from '../../../../Services/storage.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
import { FilterPipe } from 'ngx-filter-pipe';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { Title } from '@angular/platform-browser';
import { DecimalNewPipe } from '../../../common/DecimalNewPipe';
import { ConfirmDialogService } from '../../../../Services/confirm-dialog.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { BsToastService} from '../../../../Services/bs-toast-service';
import {RoutingTrackerService} from '../../../../Services/routing-tracker.service';
import {forkJoin} from 'rxjs';
import {NavigationService} from '../../../../Services/navigation.service';


@Component({
  selector: 'app-transfer-form',
  templateUrl: './transfer-form.component.html',
  styleUrls: ['./transfer-form.component.css'],
  standalone: false
})
export class TransferFormComponent extends TypeaheadBase implements OnInit, AfterViewInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private datePipe: DatePipe,
    private dateFilter: DateFilterService,
    private decimal: DecimalPipe,
    private titleService: Title,
    private decimalPipe: DecimalNewPipe,
    private confirmDialogService: ConfirmDialogService,
    private prevUrl: RoutingTrackerService,
    private nav: NavigationService
  ) {
    super();
    this.vm.inventoryItemFilter = { search_string: null };
    this.vm.accountFilter = { search_string: null };
    this.vm.bomFilter = { item_name: null };
    this.vm.startInventoryItem = 0;
    this.vm.startAccount = 0;
    this.vm.tempAccountDetailId = null;
    this.vm.tempItemDetailId = null;
    this.vm.printItem = {};
    this.vm.item = {};
    this.vm.getSignature = false;
    this.vm.title = $localize`:Transfer @@transfer:Transfer`;
    this.vm.deleted = [];
    this.vm.account = [];
    this.vm.company = [];
    this.vm.location = [];
    this.vm.uom = [];
    this.vm.inventoryItem = [];
    this.vm.accountSubtotal = [];
    this.vm.currency = {};
    this.vm.newAssembly = false;
    this.vm.closeAssembly = false;

    const prevUrl2 = this.prevUrl.getPreviousUrl();

    if (prevUrl2 !== null && prevUrl2 !== undefined) {
      this.routedFrom = prevUrl2;
    } else {
      this.routedFrom = '';
    }
  }
  @ViewChild('sPad', { static: true }) signaturePadElement;


  vm: any = {
    header: {
      completed: false,
      from_location_id: '',
      to_location_id: '',
    },
    item: {
      attachments: [],
    },
    detail: {
      location_id: '',
    },
    auditTrial: {},
  };

  originalSnapshot: any = null;

  tempitems: any = {};
  confirmDelete;
  submitted = false;
  fromLocation = '';
  public toLocation = '';

  routedFrom = '';

  buttonConfig: any = {
    save: true,
    close: true,
    reset: false,
    delete: true,
    saveNew: false,
    saveClose: true,
    delivered: true,
    print: true,
  };
    saveCloseFlag = false;

  isLoaded = false;
  isNew = false;
  selectedToLocationName = '';
  selectedFromLocationName = '';

  protected readonly window = window;

  accountTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.accountName, 10);

  buildSnapshot() {
    return JSON.parse(JSON.stringify(this.vm.item ?? {}));
  }

  private setBaseline() {
    this.originalSnapshot = this.buildSnapshot();
  }

  hasChanges(): boolean {
    if (!this.originalSnapshot) {
      return false;
    }
    return JSON.stringify(this.buildSnapshot()) !== JSON.stringify(this.originalSnapshot);
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }

  ngOnInit() {

    this.isLoaded = false;

    this.vm.auditTrail = true;

    this.route.queryParamMap.pipe().subscribe({
      next: (params: ParamMap) => {
        this.vm.transferId = params.get('transferId');
        this.vm.batchId = params.get('batchId');
        if (this.vm.transferId == 'new') {
          this.isNew = true;
        }

        // if (this.vm.transferId != 'new') {
        //   this.vm.item = {
        //     batch: {},
        //     header: {},
        //     detail: [],
        //   };
        // }
      },
      error: (err: any) => {
        console.error('Error in queryParamMap subscription:', err);
      },
      complete: () => {
        // console.log('Completed queryParamMap subscription');
      }
    });

    this.vm.item = {
      batch: {},
      header: {},
      detail: [],
    };

    this.tableDataService
      .getData('currency?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.currency = result.Data;
      });

    if (this.vm.transferId !== 'new') {
      // get all the lookups etc. AND entry
      forkJoin([
        this.tableDataService.getData('location?state=active&pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('account?state=active&pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('account_subtotal_no_parents?pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('company?pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('item?state=active&pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('uom?state=active&pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('currency?state=active&pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('entry', this.vm.transferId)
      ]).pipe().subscribe({
        next: (result) => {
          this.vm.location = result[0]?.Data || [];
          this.vm.account = result[1]?.Data || [];
          this.vm.accountSubtotal = result[2]?.Data || [];
          this.vm.company = result[3]?.Data || [];
          this.vm.inventoryItem = result[4]?.Data || [];
          this.vm.uom = result[5]?.Data || [];
          this.vm.currency = result[6].Data;

          this.vm.item = result[7];
          this.vm.buttonsDisabled = this.vm.item.header.completed;
          this.tempitems = Object.assign({}, this.vm.item.header);
        },
        error: (err) => {
          console.error('Error fetching lookup data:', err);
        },
        complete: () => {
          this.isLoaded = true;
          this.init();
        }
      });
    } else if (this.vm.transferId == 'new') {
      // get all the lookups etc.
      forkJoin([
        this.tableDataService.getData('location?state=active&pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('account?state=active&pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('account_subtotal_no_parents?pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('company?pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('item?state=active&pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('uom?state=active&pageNumber=0&pageSize=999999'),
        this.tableDataService.getData('currency?state=active&pageNumber=0&pageSize=999999')
      ]).subscribe({
        next: (result) => {
          this.vm.location = result[0]?.Data || [];
          this.vm.account = result[1]?.Data || [];
          this.vm.accountSubtotal = result[2]?.Data || [];
          this.vm.company = result[3]?.Data || [];
          this.vm.inventoryItem = result[4]?.Data || [];
          this.vm.uom = result[5]?.Data || [];
          this.vm.currency = result[6]?.Data || [];
        },
        error: (err) => {
          console.error('Error fetching lookup data:', err);
        },
        complete: () => {
          this.isLoaded = true;
          this.init();
        }
      });
    }

    if (this.vm.transferId != 'new') {
      this.buttonConfig.reset = false;
    }
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.vm.title);
  }

  isFieldEmpty(value: any): boolean {
    let retVal = false;
    if (!value) {
      retVal = true;
    } else {
      retVal = false;
    }
    return retVal;
  }

  setFromLocation(location: any){
    const loc = this.vm.location.find(x => x.id == location);
    this.fromLocation = loc.name;
    this.selectedFromLocationName = loc.name;
  }

  setToLocation(location: any){
    const loc = this.vm.location.find(x => x.id == location);
    this.toLocation = loc.name;
    this.selectedToLocationName = loc.name;
    // console.log('in set to location:' + location + ' ' + this.toLocation);
  }

  noDetailExists(): boolean {
    if (this.vm.item.detail.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  init() {
    if (this.vm.transferId == 'new') {
      this.vm.item.batch = {type_id: 15};
      this.vm.item.header = {header_date: new Date()};
      this.vm.item.detail = [];
    } else {
      const tempDate = this.tempitems.header_date;
      this.vm.item.header.header_date = new DatePipe('en-US').transform(tempDate, 'MM/dd/yyyy');
      if (this.vm.item.header.due_date) {
        this.vm.item.header.due_date = new DatePipe('en-US').transform(this.vm.item.header.header_date, 'MM/dd/yyyy');
      }
      this.vm.item.header.company_id = this.vm.company[0].id;

      for (const detail of this.vm.item.detail) {
        if (!this.vm.from_location_id && detail.control_line === true) {
          this.vm.from_location_id = detail.location_id;
          this.setFromLocation(detail.location_id);
        }
        if (!this.vm.to_location_id && detail.control_line === false) {
          this.vm.to_location_id = detail.location_id;
          this.setToLocation(detail.location_id);
        }
        detail.quantity = Number(detail.quantity);
        detail.display_quantity = -detail.quantity;
        if (detail.item_id) {
          const filteredInventory = this.FilterObject(this.vm.inventoryItem, {id: detail.item_id}, true);
          if (filteredInventory.length > 0) {
            detail.itemInput = filteredInventory[0].code;
          }
        }
        const filteredAccount = this.FilterObject(this.vm.account, {id: detail.account_id}, true);
        if (filteredAccount.length > 0) {
          detail.accountInput = `${filteredAccount[0].number} ${filteredAccount[0].name}`;
        }
      }
    }

    this.vm.newItemId = '';

    if (this.vm.company.length === 1) {
      this.vm.item.header.company_id = this.vm.company[0].id;
    }

    if (this.vm.currency.length === 1) {
      this.vm.item.header.currency_id = this.vm.currency[0].id;
    }

    this.vm.accountName = [];

    for (const [y, value] of Object.entries(this.vm.account)) {
      const tempName = this.vm.account[y].number + ' ' + this.vm.account[y].name;
      this.vm.accountName.push({
        name: tempName,
      });
    }

    if (this.vm.transferId === 'new') {
    this.addRows(2);
  }
    this.buildInventoryItemName();
    this.setBaseline();
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  accountSelected(id) {
    // console.log('in account selected');
    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      if (this.vm.item.detail[x].id == id) {
        this.vm.item.detail[x].account_id = '';
        for (const [y, val] of Object.entries(this.vm.account)) {
          if (this.vm.account[y].number + ' ' + this.vm.account[y].name == this.vm.item.detail[x].accountInput) {
            this.vm.item.detail[x].account_id = this.vm.account[y].id;
            break;
          }
        }
        break;
      }
    }
  }

  onAccountBlur(typeahead: any, detailId: any) {
    if (typeahead?.isPopupOpen?.()) {
      return;
    }
    this.accountSelected(detailId);
  }

  addRows(qty) {
    if (this.vm.item.header.signature) {
      return;
    }
    if (qty === '') {
      qty = 0;
    }
    let maxSortOrder = 0;
    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      if (maxSortOrder < this.vm.item.detail[x].sort_order) {
        maxSortOrder = this.vm.item.detail[x].sort_order;
      }
    }
    for (let x = 0; x < qty; x++) {
      maxSortOrder++;
      this.vm.item.detail.push({
        id: maxSortOrder,
        sort_order: maxSortOrder,
        quantity: 0,
      });
    }
  }

  calcToDetails() {
    // get the currency info
    // const companyId = this.getLocationCompanyId(this.vm.from_location_id);
    this.vm.item.header.currency_id = this.getCurrencyId(this.vm.item.header.company_id);
    // set control line values - those attached to from loc are negative vals so lets make control
    for (let x = this.vm.item.detail.length - 1; x >= 0; x--) {
      if (this.vm.item.detail[x].quantity < 0) {
        this.vm.item.detail[x].control_line = true;
      } else {
        this.vm.item.detail[x].control_line = false;
      }
    }

    // set from amd to locs just to be sure
    this.vm.item.header.from_location_id = this.vm.from_location_id;
    this.vm.item.header.to_location_id = this.vm.to_location_id;
  }

  createToRecord() {
    // adds a line for each from record user has entered

    for (const [y, val] of Object.entries(this.vm.item.detail)) {
      // from records carry a negative to decrease the number of items we transfer
      if (this.vm.item.detail[y].quantity < 0) {
        this.vm.item.detail.push({
          id: this.vm.item.detail.length + 1,
          sort_order: this.vm.item.detail.length + 1,
          itemInput: this.vm.item.detail[y].itemInput,
          accountInput: this.vm.item.detail[y].accountInput,
          item_id: this.vm.item.detail[y].item_id,
          uom_id: this.vm.item.detail[y].uom_id,
          description:
            this.getInvItemName(this.vm.item.detail[y].item_id) +
            ' (' +
            this.getLocationName(this.vm.from_location_id) +
            ' --> ' +
            this.getLocationName(this.vm.to_location_id) +
            ')',
          quantity: this.vm.item.detail[y].quantity * -1,
          display_quantity: this.vm.item.detail[y].display_quantity * -1,
          amount: this.vm.item.detail[y].amount * -1,
          debit_credit: this.vm.item.detail[y].debit_credit * -1,
          account_id: this.vm.item.detail[y].account_id,
          control_line: false,
          location_id: this.vm.to_location_id,
        });
      }
    }
  }

  clearLineItems() {
    this.vm.item.detail = [];
    this.addRows(1);
  }

  sumOfDetailLines(): number {
    let sum = 0;

    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      sum = sum + this.vm.item.detail[x].quantity;
    }
    return sum;
  }

  getCurrencyId(companyId: string) {
    let curId = '';

    for (const co of this.vm.company) {
      if (co.id === companyId) {
        curId = co.currency_id;
      }
    }
    return curId;
  }

  getLocationName(id: string): string {
    let name = '';

    if (id === undefined) {
      id = this.vm.from_location_id;
    }
    for (const loc of this.vm.location) {
      if (loc.id === id) {
        name = loc.name;
      }
    }
    return name;
  }

  getLocationCompanyId(locationId: string): string {
    let coId = '';

    for (const loc of this.vm.location) {
      if (loc.id === locationId) {
        coId = loc.company_id;
      }
    }
    return coId;
  }

  getInvItemName(id: string): string {
    let name = '';

    if (id === undefined) {
      return 'empty';
    }
    for (const item of this.vm.inventoryItem) {
      if (item.id === id) {
        name = item.name;
      }
    }
    return name;
  }

  save() {
    this.submitted = true;
    this.calcToDetails();

    if (this.sumOfDetailLines() != 0) {
      this.notification.showWarningToast('Transfer quantities do not balance between Locations.');
      return;
    }

    if (!this.vm.item.attachments) {
      this.vm.item.attachments = [];
    }
    let error = 0;
    let warnMsg = '';

    if (!this.vm.item.header.header_date || !this.vm.item.header.company_id) {
      if (!this.vm.item.header.number) {
        // this.notification.warning($localize`:Company is required. @@companyisrequired:Company is required.`);
        this.vm.numberMissingError = true;
        warnMsg += $localize`:Number is required. @@numberisrequired:Number is required.` + '</br>';
        error = 1;
      }
      if (!this.vm.item.header.header_date) {
        // this.notification.warning($localize`:Date is required @@dateisrequired:Date is required`);
        this.vm.dateMissing = true;
        warnMsg += $localize`:Date is required @@dateisrequired:Date is required` + '</br>';
        error = 1;
      }
      if (!this.vm.item.header.company_id) {
        // this.notification.warning($localize`:Company is required. @@companyisrequired:Company is required.`);
        this.vm.companyError = true;
        warnMsg += $localize`:Company is required. @@companyisrequired:Company is required.` + '</br>';
        error = 1;
      }
    } // else {

    let yearEndDate = this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0].year_end_date;
    let cutOffDate = this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0].cut_off_date;
    const tempYearEndDate = new Date(yearEndDate);
    const tempCutOffDate = new Date(cutOffDate);
    const headerDate = new Date(this.vm.item.header.header_date);

    if (headerDate < tempYearEndDate) {
      yearEndDate = this.dateFilter.GetDateFormat(yearEndDate);
      warnMsg +=
        $localize`:Date must be greater than the year end  @@datemustbegreaterthantheyearend:Date must be greater than the year end ` +
        yearEndDate +
        '</br>';
      error = 1;
    }
    if (headerDate < tempCutOffDate) {
      cutOffDate = this.dateFilter.GetDateFormat(cutOffDate);
      warnMsg +=
        $localize`:Date must be greater than the cut off date  @@datemustbegreaterthanthecutoffdate :Date must be greater than the cut off date ` +
        cutOffDate +
        '</br';
      error = 1;
    }
    this.vm.item.header.header_date = this.dateFilter.GetDateFormat(this.vm.item.header.header_date);

    if (!this.vm.from_location_id) {
      this.vm.locationError = true;
      warnMsg += $localize`:From Location is required.  @@fromLocationisrequired:From Location is required. ` + '</br>';
      error = 1;
    }

    if (!this.vm.to_location_id) {
      this.vm.locationError = true;
      warnMsg += $localize`:To Location is required.  @@toLocationisrequired:To Location is required. ` + '</br>';
      error = 1;
    }
    if (!this.vm.item.header.description) {
      warnMsg += $localize`:Description is required.  @@descriptionisrequired:Description is required. ` + '</br>';
      this.vm.descriptionError = true;
      error = 1;
    }

    let detailFound = false;
    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      if (!this.vm.item.detail[x].debit_credit) {
        this.vm.item.detail[x].debit_credit = 0;
      }
      if (this.vm.item.detail[x].debit_credit || this.vm.item.detail[x].debit_credit === 0) {
        if (this.vm.item.detail[x].control_line == false && this.vm.item.detail[x].item_id) {
          detailFound = true;
        }
        if (!this.vm.item.detail[x].description && this.vm.item.detail[x].item_id) {
          this.notification.showWarningToast('Detail Description is required.');
          error = 1;
        }
        if (!this.vm.item.detail[x].account_id && this.vm.item.detail[x].item_id) {
          this.notification.showWarningToast('Detail Account is required.');
          error = 1;
        }
      }
    }

    if (!detailFound) {
      warnMsg +=
        $localize`:At least one Item is required.  @@atleastoneItemisrequired:At least one Item is required. ` +
        '</br>';
      error = 1;
    }

    for (const det of this.vm.item.detail) {
      if (!det.uom_id || !det.display_quantity || !det.accountInput || !det.itemInput) {
        warnMsg += $localize`:Detail line missing values. @@detaillinemissing:Detail line missing values. ` + '</br>';
        error = 1;
      }
    }

    if (error === 1) {
      this.notification.showWarningToast(warnMsg);
      return;
    }

    if (error === 0) {
      this.vm.buttonsDisabled = true;
      if (this.vm.item.header.id === undefined || this.vm.item.header.id === 'new') {
        // new
        this.tableDataService.post('entry', this.vm.item).subscribe({
          next: (item: any) => {
            this.vm.buttonsDisabled = false;
            this.submitted = false;
            this.setBaseline();
            if (!this.saveCloseFlag) {
              this.router.navigateByUrl('/inventory/transfer/form?transferId=' + item.id).then();
            }
          },
          error: (errors: any) => {
            this.vm.buttonsDisabled = false;
            console.log(errors);
          }
        });
      } else {
        // edit
        if (!this.vm.item.header.signature) {
          if (this.vm.linkedSignature) {
            this.vm.item.header.signature = this.vm.linkedSignature;
          }
        }
        const params = {
          id: this.vm.item.header.id,
          tablename: 'entry',
        };

        // diff
        const changes: any = {};

        changes.detail = this.vm.item.detail;
        changes.salesperson = this.vm.item.salesperson;
        changes.attachments = this.vm.item.attachments;

        const headerChanges = {};

        for (const key in this.vm.item.header) {
          if (Object.prototype.hasOwnProperty.call(this.vm.item.header, key)) {
            let value = this.vm.item.header[key];
            if (value != key && key != 'entityInput') {
              if (key === 'header_date' && !value) {
                // if the date is somehow empty, add a date
                const d = new Date();
                value = this.datePipe.transform(d, 'yyyy-MM-ddTHH:mm:ss');
              }
              headerChanges[key] = value;
            }
          }
        }
        if (headerChanges) {
          changes.header = headerChanges;
        }
        // console.log('changes');
        // console.log(changes);
        this.tableDataService.patchWithParamsNew('entry', this.vm.item.header.id, changes).then(
          (item: any) => {
            this.vm.buttonsDisabled = false;
            this.setBaseline();
            if (item.description == 'Deleted') {
              this.router.navigateByUrl('/inventory/transfer/list').then();
              return;
            }
            // TODO add ability to email document see invoices as example;
            this.vm.action = '';
            this.submitted = false;
            if (!this.saveCloseFlag) {
              this.router.navigateByUrl('/inventory/transfer/form?transferId=' + this.vm.item.header.id).then();
            }
            this.vm.buttonsDisabled = false;
          },
          (er: any) => {
            this.vm.buttonsDisabled = false;
            console.log($localize`:Error @@error:Error ` + er.message);
          }
        );
      }
    } else {
      // report error
      this.vm.buttonsDisabled = false;
    }
  }

  saveNew() {
    this.save();
    this.router.navigateByUrl('/inventory/transfer/form?transferId=new&batchId=').then();
  }

  saveClose() {
    this.saveCloseFlag = true;
    this.save();
    this.onClose();
  }

  deleteLine(id) {
    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      if (this.vm.item.detail[x].id == id) {
        this.vm.item.detail.splice(x, 1);
        break;
      }
    }
  }

  // item functions
  buildInventoryItemName() {
    this.vm.inventoryItemName = [];
    for (const [y, value] of Object.entries(this.vm.inventoryItem)) {
      let tempUOM = '';
      if (this.FilterObject(this.vm.uom, { id: this.vm.inventoryItem[y].uom_id }, true).length > 0) {
        tempUOM = this.FilterObject(this.vm.uom, { id: this.vm.inventoryItem[y].uom_id }, true)[0].name;
      }
      // let tempUOMName = this.FilterObject(this.vm.uom, { id: this.vm.inventoryItem[y].uom_id }, true)[0].name;
      const tempName = this.vm.inventoryItem[y].code + ' ' + this.vm.inventoryItem[y].name + ' ' + tempUOM;
      this.vm.inventoryItemName.push({
        name: tempName,
      });
    }
  }

  updateInventoryItem() {
    this.vm.startInventoryItem = 0;
    this.tableDataService
      .getData('item?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.inventoryItem = result.Data;
      });
    this.buildInventoryItemName();
  }

  selectItemModal(event: any) {
    const itemId = event;
    const id = this.vm.tempItemDetailId;
    let maxSortOrder = 0;

    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      if (maxSortOrder < this.vm.item.detail[x].sort_order) {
        maxSortOrder = this.vm.item.detail[x].sort_order;
      }
    }
    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      if (this.vm.item.detail[x].id == id) {
        this.vm.item.detail[x].item_id = '';

        for (const [y, val] of Object.entries(this.vm.inventoryItem)) {
          if (this.vm.inventoryItem[y].id == itemId) {
            this.vm.item.detail[x].header_id = this.vm.item.header.id;
            this.vm.item.detail[x].description =
              this.getInvItemName(this.vm.inventoryItem[y].id) +
              ' (' +
              this.getLocationName(this.vm.from_location_id) +
              ' --> ' +
              this.getLocationName(this.vm.to_location_id) +
              ')';
            this.vm.item.detail[x].itemInput = this.vm.inventoryItem[y].code;
            this.vm.item.detail[x].item_id = this.vm.inventoryItem[y].id;
            this.vm.item.detail[x].uom_id = this.vm.inventoryItem[y].uom_id;
            this.vm.item.detail[x].account_id = 'in';
            this.vm.item.detail[x].display_quantity = -1;
            this.vm.item.detail[x].quantity = -1;
            this.vm.item.detail[x].amount = this.vm.inventoryItem[y].cost * -1;
            this.vm.item.detail[x].debit_credit = 0 - this.vm.inventoryItem[y].cost;
            this.vm.item.detail[x].location_id = this.vm.item.header.from_location_id;
            maxSortOrder++;
            break;
          }
        }
        break;
      }
    }
  }

  print() {
    this.vm.action = 'print';
    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      if (this.FilterObject(this.vm.uom, { id: this.vm.item.detail[x].uom_id }, true).length > 0) {
        this.vm.item.detail[x].uom = this.FilterObject(
          this.vm.uom,
          { id: this.vm.item.detail[x].uom_id },
          true
        )[0].code;
      }
    }
    if (this.vm.item.header.entity_id) {
      if (this.FilterObject(this.vm.entity, { id: this.vm.item.header.entity_id }, true)) {
        this.vm.item.header.entityInput = this.FilterObject(
          this.vm.entity,
          { id: this.vm.item.header.entity_id },
          true
        )[0].name;
      }
    }
    if (this.vm.from_location_id) {
      if (this.FilterObject(this.vm.location, { id: this.vm.from_location_id }, true)) {
        const tempAddress = this.FilterObject(this.vm.location, { id: this.vm.from_location_id }, true)[0];
        this.vm.printItem.location1Name = tempAddress.name;
        if (tempAddress.address_1) {
          this.vm.printItem.location1Address1 = tempAddress.address_1;
        }
        if (tempAddress.city) {
          this.vm.printItem.location1Address2 = tempAddress.city;
        }
        if (tempAddress.state) {
          this.vm.printItem.location1Address2 += ', ' + tempAddress.state;
        }
        if (tempAddress.zip) {
          this.vm.printItem.location1Address2 = tempAddress.zip;
        }
      }
    }

    if (this.vm.to_location_id) {
      if (this.FilterObject(this.vm.location, { id: this.vm.to_location_id }, true)) {
        const tempAddress = this.FilterObject(this.vm.location, { id: this.vm.to_location_id }, true)[0];
        this.vm.printItem.location2Name = tempAddress.name;
        if (tempAddress.address_1) {
          this.vm.printItem.location2Address1 = tempAddress.address_1;
        }
        if (tempAddress.city) {
          this.vm.printItem.location2Address2 = tempAddress.city;
        }
        if (tempAddress.state) {
          this.vm.printItem.location2Address2 += ', ' + tempAddress.state;
        }
        if (tempAddress.zip) {
          this.vm.printItem.location2Address2 = tempAddress.zip;
        }
      }
    }

    // set company address
    if (this.vm.item.header.company_id) {
      if (this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0]) {
        const tempAddress = this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0];
        this.vm.printItem.companyLogo = tempAddress.logo;
        this.vm.printItem.companyName = tempAddress.name;
        this.vm.printItem.companyAddress1 = tempAddress.address_1;
        this.vm.printItem.companyAddress2 = tempAddress.city;
        if (tempAddress.state) {
          this.vm.printItem.companyAddress2 += ', ' + tempAddress.state;
        }
        this.vm.printItem.companyAddress2 += '  ' + tempAddress.zip;
        this.vm.printItem.companyTaxNumber = tempAddress.tax_number;
      }
    }
    for (const [x, val] of Object.entries(this.vm.inventoryItem)) {
      for (const [y, value] of Object.entries(this.vm.item.detail)) {
        if (this.vm.item.detail[y].item_id == this.vm.inventoryItem[x].id) {
          this.vm.item.detail[y].itemInput = this.vm.inventoryItem[x].code;
        }
      }
    }

    // print only images
    this.vm.printItem.images = [];
    this.vm.item.attachments.forEach((element) => {
      if (element.type.includes('png', 'jpg', 'svg')) {
        this.vm.printItem.images.push(element);
      }
    });


    setTimeout(async () => {
      window.print();
      this.vm.action = '';
    }, 2000);
  }

  updateAccount() {
    this.vm.startAccount = 0;
    this.tableDataService
      .getData('account', '?pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        const data: any = result.Data;
        this.vm.account = result;
      });
  }

  selectAccountModal(accountId) {
    const id = this.vm.tempAccountDetailId;
    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      if (this.vm.item.detail[x].id == id) {
        for (const [y, val] of Object.entries(this.vm.account)) {
          if (this.vm.account[y].id == accountId) {
            this.vm.item.detail[x].account_id = this.vm.account[y].id;
            this.vm.item.detail[x].accountInput = this.vm.account[y].number + ' ' + this.vm.account[y].name;
            break;
          }
        }
        break;
      }
    }
  }

  signature(signature) {
    this.vm.linkedSignature = signature;
    this.vm.item.header.signature = signature;
    this.vm.getSignature = true;
    document.getElementById('closeSignatureModel').click();
    this.save();
  }

  deleteSignature() {
    this.vm.item.header.signature = '';
    this.vm.getSignature = true;
    document.getElementById('closeSignatureModel').click();
    this.save();
  }

  addTextSignature() {
    let text;
    if (this.vm.subLedger === 'ar' || this.vm.subLedger === 'ap') {
      text = 'Invoice ';
    }
    if (this.vm.subLedger === 'salesorders') {
      text = 'Sales Order ';
    }
    if (this.vm.subLedger === 'purchaseorders') {
      text = 'Purchase Order ';
    }
    if (this.vm.subLedger === 'quote') {
      text = 'Quote ';
    }
    if (this.vm.item.header.number) {
      text += 'Number: ' + this.vm.item.header.number + '      ';
    }
    let itemCount = 0;
    for (const [x, value] of Object.entries(this.vm.item.detail)) {
      itemCount += Number(this.vm.item.detail[x].quantity);
    }
    text += 'Total: $' + this.decimalPipe.transform(this.vm.total);
    this.vm.addTextSignature = text;
  }

  syncItemAttachments(attachmentsArray: any) {
    // console.log('attachments array recvd in main');
    // console.log(attachmentsArray);

    // clear existing - will be put back because in array passed back in file upload array
    this.vm.item.attachments = [];

    // use the pieces needed for the api record
    attachmentsArray.forEach((x) => {
      this.vm.item.attachments.push({
        id: x.id,
        header_id: x.header_id,
        file_name: x.fileName,
        type: x.fileType,
        attachment: x.fileData,
        audit_sequence: 0
      });
    });
    // console.log('main vm array after sync to file upload data');
    // console.log(this.vm);
  }

  gotAnUploadFile(file: any) {
    // console.log('in got a file: ' + file);
    // console.log('in got a file: ');
  }

  delivered() {
    if (this.vm.transferId != 'new') {
      this.vm.item.header.completed = true;
      this.save();
    }
  }

  onClose() {
    const fallback = '/inventory/transfer/list';
    this.nav.backOr(fallback);
  }

  deleteItem() {
    if (this.vm.transferId != 'new') {
      const brClass = this;
      // let retMsg = '';
      const messages: string[] = [
        $localize`:Are you sure you want to delete record? @@areyousureyouwanttodeleterecord:Are you sure you want to delete record?`,
        '' + this.vm.item.header.number,
      ];
      this.confirmDialogService.confirmThis(
        messages,
        () => {
          this.vm.item.header.deleted = true;
          this.save();
        },
        () => {
          brClass.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
        }
      );
    }
  }
}
